import { BluetoothSerialCommService } from '@services/bluetooth/BluetoothSerialCommService'
import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'

// Public functions

/**
 * Cross frame listener for serial communication devices.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'print', etc...
 *          parameters: {object} - object containing the parameters for the print call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function bluetoothSerialCommListener (message: any) {

    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {

    case 'writeDataSerialComm':
    /**
     * Sends data to the serially connected bluetooth device.
     */
        return BluetoothSerialCommService.writeDataSerialComm(params)
    case 'requestDataSerialComm':
    /**
     * Sends command to the serially connected bluetooth device and receives data from it.
     */
        return BluetoothSerialCommService.requestDataSerialComm(params)
    case 'changeCharsetSerialComm':
    /**
     * Sends new charset to the serially connected bluetooth device.
     */
        return BluetoothSerialCommService.changeCharsetSerialComm(params)
    case 'disconnectSerialComm':
    /**
     * disconnects the serially connected bluetooth device.
     */
        return BluetoothSerialCommService.disconnectSerialComm(params)
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
